import styled from "styled-components";

export const StepperContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 536px;
	height: 40px;
	margin: 0 auto 32px auto;
	position: relative;
`;

export const StepLineFirst = styled.div`
	position: absolute;
	top: 50%;
	left: 40px;
	width: 228px;
	height: 2px;
	background-color: ${props => (props.active ? "#534B99" : "#E4E4E7")};
	transform: translateY(-50%);
	z-index: 1;
`;

export const StepLineSecond = styled.div`
	position: absolute;
	top: 50%;
	left: 268px;
	width: 228px;
	height: 2px;
	background-color: ${props => (props.active ? "#534B99" : "#E4E4E7")};
	transform: translateY(-50%);
	z-index: 1;
`;

export const StepContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 2;
`;

export const StepCircle = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	background-color: ${props => (props.active ? "#534B99" : "#FFFFFF")};
	color: ${props => (props.active ? "#FFFFFF" : "#31475A")};
	border: ${props => (props.active ? "none" : "1px solid #E4E4E7")};
`;
